import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getFeaturedProducts, getImageUrl } from "../services/api";
import ProductCard from "../components/ProductCard";
import "./Home.css";

const Home = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [logoUrl, setLogoUrl] = useState("");
  const [heroBackgroundUrl, setHeroBackgroundUrl] = useState("");
  const [aboutImageUrl, setAboutImageUrl] = useState("");
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    setLogoUrl(getImageUrl("logo"));
    setAboutImageUrl(getImageUrl("about-home"));
    const heroUrl = getImageUrl("hero-home");
    
    // Précharger l'image hero et attendre qu'elle soit chargée
    const img = new Image();
    img.onload = () => {
      setHeroBackgroundUrl(heroUrl);
      setImageLoaded(true);
    };
    img.onerror = () => {
      // En cas d'erreur, afficher quand même le gradient
      setImageLoaded(true);
    };
    img.src = heroUrl;
  }, []);

  useEffect(() => {
    const loadFeaturedProducts = async () => {
      try {
        const response = await getFeaturedProducts();
        setFeaturedProducts(response.data);
      } catch (error) {
        if (process.env.NODE_ENV === 'development') console.error("Erreur lors du chargement des produits:", error);
      } finally {
        setLoading(false);
      }
    };

    loadFeaturedProducts();
  }, []);

  return (
    <div className="home">
      {/* Hero Section */}
      <section className={`hero ${imageLoaded ? 'loaded' : 'loading'}`} style={{ backgroundImage: heroBackgroundUrl ? `url(${heroBackgroundUrl})` : 'none' }}>
        <div className="hero-content">
          <img src={logoUrl} alt="Personal Regrets" className="hero-logo" />
          <p className="hero-subtitle">Prêt à assumer vos faiblesses ?</p>
          <Link to="/shop" className="btn btn-primary">
            Commande dès maintenant
          </Link>
        </div>
        <div className="hero-gradient"></div>
      </section>

      {/* Featured Products */}
      <section className="section featured-section">
        <div className="container">
          <h2 className="section-title">Nouveautés</h2>
          {loading ? (
            <div className="loading">Chargement...</div>
          ) : (
            <div className="products-grid">
              {featuredProducts.slice(0, 4).map((product) => (
                <ProductCard key={product._id} product={product} />
              ))}
            </div>
          )}
          {featuredProducts.length === 0 && !loading && (
            <p className="no-products">
              Aucun produit disponible pour le moment.
            </p>
          )}
        </div>
      </section>

      {/* About Section */}
      <section className="section about-preview">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>À propos de nous</h2>
              <p>Bienvenue chez <b>PR</b><br />
                <i>Porte fièrement tes faiblesses</i>
              </p>
              <p>
                On est deux frères, tous les deux passionnés de <b>CrossFit</b>. Ensemble on réunit le design et l’humour.
              </p>
              <p>
                Le but ? Ne pas se prendre au sérieux et être à fond dans l’<b>autodérision</b>.
                <br />On s’adresse à celles et ceux qui rament au rameur, qui pleurent aux HSPU et qui brillent en No-Rep. Tu t’es reconnu ?
                <br />T’inquiète, on est tous passés par là.
              </p>
              <Link to="/about" className="btn btn-secondary">
                En savoir plus
              </Link>
            </div>
            <div className="about-image">
              {aboutImageUrl && (
                <img src={aboutImageUrl} alt="À propos de nous" />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="section values-section">
        <div className="container">
          <h2 className="section-title">Nos valeurs</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">🎨</div>
              <h3>Design</h3>
              <p>
                Des visuels forts, propres et identitaires.
                Beaux au premier regard, ironiques au second
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">😂</div>
              <h3>Humour</h3>
              <p>De l’autodérision, jamais du mépris.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">✅</div>
              <h3>Qualité</h3>
              <p>
                Matières solides, confort. Impression DTF durable. Testées
                pour la box, validées pour le quotidien.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">🏋️</div>
              <h3>Communauté</h3>
              <p>
                RX, Scaled, débutant ou compétiteur
                Si tu t’identifies, tu es chez toi.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
